/**
 * @enum LvfVehicleStructureType
 *  * @classdesc Represents the supported EquipmentVehicle Structure type.
 */
export enum LvfVehicleStructureType {

  BACHE = 1,
  BEN_CERE = 2,
  BENNE = 3,
  CI = 4,
  CIT_BETA = 5,
  DERIV_VP = 6,
  FG_TD = 7,
  FOURGON = 8,
  NON_SPEC = 9,
  PLATEAU = 10,
  PLSC = 11,
  PR_SREM = 12,
  PTE_CONT = 13,
  PTE_ENG = 14,
  PTE_FER = 15,
  PTE_VOIT = 16,
  SAVOYARDE = 17,
  VTTE = 18,
  W_GARAGE = 19
}
